module.exports = __webpack_public_path__ + "static/27invgde-ec1f6f0c7cacbcab1c67dec10262ac72.gif";